import React from 'react';
import { Avatar, Space, Tag } from 'antd';
import { EyeOutlined, UserOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { dateFormat } from '../utils';
import { CheckCircleTwoTone, ScheduleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';

function getShortZoneName(league) {
    if (league && league.lpiZone) {
        return league.lpiZone.zoneShortname;
    }
    
    return '';

}

function getTOs(tournament) {
    if (tournament && tournament.leagueInfos) {
        return tournament.leagueInfos.leagueName;
    }
    return 'N.A.';
}

function getTournamentStatus(tournament) {
    if (tournament && tournament.isDone) {
        return (<CheckCircleTwoTone twoToneColor="#52c41a" />)
    }
    return (<ScheduleTwoTone />)
}

function formatLeagueStatus(league) {
    if (league && league.status) {
        return (<CheckCircleTwoTone twoToneColor="#52c41a" />)
    }
    return (<CloseCircleTwoTone twoToneColor="#eb2f96" />)
}

export function filterByes(byes, id) {
    let results = [];
    if (byes && byes.length > 0) {
        results = byes.filter((bye) => {
            return bye.tournamentId == id
        })

    }
    return results;
}

export const playerCols = [
    {
        title: 'Name',
        dataIndex: 'firstName',
        key: 'name',
        render: (state, record) => <span>{record.firstName} {record.lastName}</span> 
    },
    {
        title: 'Actions',
        dataIndex: 'id',
        render: (state, record) => (<Space><Link to={'/players/'+record.id+'/'}>
                    <EyeOutlined />
                </Link>
                </Space>),
    }
  ];

export const leagueCols = [
    {
        title: 'Name',
        dataIndex: 'leagueName',
        key: 'name',
        width: '35%',
        render: (state, record) => (<Space><Link to={'/leagues/'+record.id+'/'} viewTransition>{record.leagueName}</Link></Space>),
        sorter: (a, b) => { 
            // console.warn(a,b);
            if (a.leagueName == b.leagueName) {
              return 0;
            }
            
            if (a.leagueName < b.leagueName) {
              return 1;
            } else {
              return -1;
            }
          },
    },
    {
        title: 'Referral',
        dataIndex: 'referrerName',
        // render: (date) => dateFormat(date)
    },
    {
        title: 'Zone',
        dataIndex: 'lpiZone',
        width: '10%',
        render: (obj, record) => (<Space><span>{getShortZoneName(record)}</span></Space>),
        sorter: (a, b) => { 
            // console.warn(a,b);
            if (a.lpiZone.id == b.lpiZone.id) {
              return 0;
            }
            
            if (a.lpiZone.id < b.lpiZone.id) {
              return 1;
            } else {
              return -1;
            }
          },
    },
    {
        title: 'Status',
        dataIndex: 'status',
        render: (obj, record) => (<Space><span>{formatLeagueStatus(record)}</span></Space>)
    }
    /* {
        title: 'Actions',
        dataIndex: 'id',
        render: (state, record) => (<Space><Link to={'/leagues/'+record.id+'/'}>
                    <EyeOutlined />
                </Link>
                </Space>),
    } */
];

export const seasonCols = [
    {
        title: 'Season',
        dataIndex: 'name',
        key: 'name', 
    },
    {
        title: 'League',
        dataIndex: 'hostingLeague',
        key: 'hostingLeague',
        render: (state, record) => (<Space><Link to={'/leagues/'+record.hostingLeague.id+'/'}>{record.hostingLeague.leagueName}</Link></Space>)
    },
    {
        title: 'Start Date',
        dataIndex: 'startDate',
        render: (date) => dateFormat(date)
    },
    {
        title: 'End Date',
        dataIndex: 'endDate',
        render: (date) => dateFormat(date)
    },
    {
        title: 'Stages Played',
        dataIndex: 'stagesPlayed',
    },
    {
        title: 'Actions',
        dataIndex: 'id',
        render: (state, record) => (<Space><Link to={'/seasons/'+record.id+'/'}>
                    <EyeOutlined />
                </Link>
                </Space>),
    }
  ];

export const usersCols = [
    {
        title: '',
        dataIndex: 'avatar',
        key: 'avatar',
        width: 60,
        render: (avatar) => <Avatar src={avatar} style={{ backgroundColor: '#87d068' }} icon={<UserOutlined />} />,
    },
    {
        title: 'Name',
        dataIndex: 'displayName',
        key: 'name', 
    },
    /*{
        title: 'Email',
        dataIndex: 'email',
        key: 'mail',
    },*/
    {
        title: 'Roles',
        dataIndex: 'groups',
        render: (_, { groups }) => {
            console.warn('roles:', groups);
            if (groups && groups.length > 0) {
                return (<>
                    {groups.map((role) => {
                      let color;
                      let text;
                      switch(role) {
                          case 'admins':
                              color = 'green';
                              text = 'Admin';
                          break;
                          case 'referrals':
                              color = 'purple';
                              text = 'Referente';
                          break;
                          case 'storeOwner':
                              color = 'orange';
                              text = 'Gestore Negozio';
                          break;
                          case 'player':
                          default:
                              color = 'blue';
                              text = 'Giocatore';
                      }
                      return (
                        <Tag color={color} >
                          {text}
                        </Tag>
                      );
                    })}
                  </>);
            } else {
                return (<Tag color='blue' >
                    Giocatore
                  </Tag>);
            }
        },
    }, 
    {
        title: 'Actions',
        dataIndex: 'id',
        render: (state, record) => (<Space><Link to={'/user/'+record.id+'/'}>
                    <EyeOutlined />
                </Link>
                </Space>),
    }
  ];

export const cardDeckCols = [
    {
        title: 'qty',
        dataIndex: 'quantity',
        key: 'qty',
        width: 60,
    },
    {
        title: 'name',
        dataIndex: 'card',
        render: (txt, record) => (<span>{record.card.name}</span>)
    }
];

export const tournamentsCols = [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => (<Space><Link to={'/tournaments/'+record.id+'/'}>
            {text}
        </Link>
        </Space>),
    },
    {
        title: 'Date',
        dataIndex: 'date',
        sorter: (a, b) => { 
            // console.warn(a,b);
            if (a.date == b.date) {
              return 0;
            }
            
            if (a.date < b.date.id) {
              return 1;
            } else {
              return -1;
            }
          },
        render: (date) => dateFormat(date)
    },
    {
        title: 'T.O.',
        dataIndex: 'leagueOrganizer',
        render: (txt, record) => getTOs(record)
    },
    {
        title: 'Type',
        dataIndex: 'type',
        render: (txt, record) => (<span>{record.type.desc}</span>),
        filters: [
            { text: 'Finale di Lega(0 BYE)', value: 14},
            { text: 'Finale di Lega(1 BYE)', value: 1},
            { text: 'Finale di Lega(2 BYE)', value: 2},
            { text: 'Finale di Lega(4 BYE)', value: 3},
            { text: 'PTE', value: 4},
            { text: 'CTT', value: 5},
            { text: 'Big Event', value: 6},
            { text: 'IPT', value: 7},
            { text: 'Last Chance', value: 9},
            { text: 'TPP', value: 10},
            { text: 'Paupergeddon', value: 11},
            // { text: 'Tappa di Lega', value: 12},
            { text: 'Super IPT(1 BYE)', value: 13},
        ],
        onFilter: (value, record) => record.type.id == value,
    },
    {
        title: 'Participants',
        dataIndex: 'playerAttendancy'
    },
    {
        title: 'Status',
        dataIndex: 'isDone',
        render: (idx, record) => getTournamentStatus(record)
    },
];

export const byesCols = [
    {
        title: 'Player',
        dataIndex: 'playerInfo',
        render: (txt, record) => (<Space><Link to={'/players/'+record.playerId+'/'}>
            {record.playerInfo.firstName} {record.playerInfo.lastName}
        </Link>
        </Space>)
    },
    {
        title: 'Tournament',
        dataIndex: 'tournamentInfo',
        render: (txt, record) => (<Space><Link to={'/tournaments/'+record.tournamentId+'/'}>
            {record.tournamentInfo.name}
        </Link>
        </Space>)
    },
    {
        title: 'PauperGeddon',
        dataIndex: 'seasonLPI',
        render: (txt, record) => (<Space>{record.seasonLPI.desc}</Space>)
    }
];

export function convertToScatterplotData(rawData, idLabel,xLabel,yLabel) {
    const scatterPlotData = [];
    if (Array.isArray(rawData) && rawData.length > 0) {
        console.warn()
        rawData.forEach((element) => {
            const spe = {
                id: element[idLabel],
                data: [
                    {
                        x: element[xLabel],
                        y: element[yLabel],
                    }
                ]
            }
            scatterPlotData.push(spe)
        })
    }
    
    //console.warn('convertToScatterPlotData result:', scatterPlotData);
    return scatterPlotData;
} 